export const useEntity = () => usePage().value.page.entity;